import { render, staticRenderFns } from "./OnBoardingLoader.vue?vue&type=template&id=3c3ae336&scoped=true"
import script from "./OnBoardingLoader.vue?vue&type=script&lang=js"
export * from "./OnBoardingLoader.vue?vue&type=script&lang=js"
import style0 from "./OnBoardingLoader.vue?vue&type=style&index=0&id=3c3ae336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ae336",
  null
  
)

export default component.exports